import { render, staticRenderFns } from "./BajaTrabajador.vue?vue&type=template&id=c2908232&"
import script from "./BajaTrabajador.vue?vue&type=script&lang=js&"
export * from "./BajaTrabajador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports